import React from 'react';
import { Configure, InstantSearch, SearchBox } from 'react-instantsearch-dom';

import { indexName, searchClient } from '.';
import NavigationHits from './NavigationHits';

const NavigationSearch = () => (
  <InstantSearch indexName={indexName} searchClient={searchClient}>
    {/* https://www.algolia.com/doc/api-reference/search-api-parameters */}
    <Configure
      hitsPerPage={100}
      distinct={1}
      queryLanguages={['de']}
      ignorePlurals
      removeStopWords
    />
    {/* https://www.algolia.com/doc/api-reference/widgets/search-box/react */}
    <SearchBox
      submit={<img src="/assets/icon-24px-search-outline.png" />}
      onSubmit={(e) => {
        e.preventDefault();

        const query = e.currentTarget.querySelector('input').value;

        // navigate to the search page with the current query as parameter
        window.location.href = `/suche?q=${query}`;
      }}
      reset={<img src="/assets/icon-24px-close-outline.png" />}
      translations={{
        submitTitle: 'Suche abschicken',
        resetTitle: 'Sucheingabe löschen',
        placeholder: 'Suche'
      }}
    />
    {/* https://www.algolia.com/doc/api-reference/widgets/hits/react */}
    <NavigationHits />
  </InstantSearch>
);

export default NavigationSearch;



// WEBPACK FOOTER //
// ./components/search/NavigationSearch.js